exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saved-reply-top-row .el-input__inner {\n  min-height: 2.5rem;\n}\n", ""]);

// exports
